module.exports = __webpack_public_path__ + "img/course_empty.165baf27.png";